import { trpc } from '@/services/trpc';

export function useShopProductMutation() {
  const utils = trpc.useUtils();

  const update = trpc.shopProducts.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.shopProducts.findAll.invalidate(),
        utils.shopProducts.findOne.invalidate({ id }),
        // Active/status transitions shift the feed's count formulas
        // (pendingProductsCount etc.) that ProductStatsSummary reads.
        utils.feeds.findOne.invalidate(),
        utils.feeds.findAll.invalidate(),
      ]);
    },
  });

  const reEmbed = trpc.shopProducts.reEmbed.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.shopProducts.findAll.invalidate(),
        utils.shopProducts.findOne.invalidate({ id }),
        utils.feeds.findOne.invalidate(),
        utils.feeds.findAll.invalidate(),
      ]);
    },
  });

  return {
    update,
    reEmbed,
  };
}
